import { render, staticRenderFns } from "./ModalConfirmPrivate.vue?vue&type=template&id=2caaa799&"
import script from "./ModalConfirmPrivate.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmPrivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports